import React, { useRef, useState } from 'react';
import cx from 'classnames';

import { CustomEditable, CustomSlate, useRichSlateEditor } from 'src/components/RichSlate';
import { useSubscribeForDocumentExports } from 'src/services/document';
import { useActiveVariationInstanceId } from './services';
import { DocumentScores } from './views/DocumentScores';
import { useViewState } from './useViewState';
import { useHandlers } from './useHandlers';
import { DetailsPanelPortalContextProvider } from './context';
import { useStyles } from './useStyles';

export const PanelDocument = ({ className }) => {
  const activeVariationInstanceId = useActiveVariationInstanceId();
  const styles = useStyles({ activeVariationInstanceId });

  // Element ref for mounting "details panel" views
  const refPortalDetailsPanel = useRef();

  const editorInstance = useRichSlateEditor();
  const [rootElement, setRootElement] = useState(null);

  // Support document export through "share popup"
  useSubscribeForDocumentExports(editorInstance);

  const { projectData } = useViewState();
  const editorContent = projectData?.editorContent;

  const { handleEditableMouseMove, handleEditableMouseLeave } = useHandlers();

  if (!editorContent) {
    return null;
  }

  return (
    <DetailsPanelPortalContextProvider value={refPortalDetailsPanel}>
      <div
        className={cx(styles.root, className)}
        ref={setRootElement}
      >
        <CustomSlate
          editor={editorInstance}
          value={editorContent}
          convertToHtml
        >
          <div className="relative mt-[45px]">
            <CustomEditable
              className={cx(styles.editable, 'text-neutral-secondary text-base')}
              onMouseMove={handleEditableMouseMove}
              onMouseLeave={handleEditableMouseLeave}
              readOnly
            />

            {rootElement && (
              <DocumentScores
                className={styles.documentScores}
                parentElement={rootElement}
              />
            )}
          </div>
        </CustomSlate>

        <div
          className={styles.portalDetailsPanel}
          ref={refPortalDetailsPanel}
        />
      </div>
    </DetailsPanelPortalContextProvider>
  );
};
